// extracted by mini-css-extract-plugin
export default {"cityBrowsePoiShelf":"ThingsToDoPage-module__cityBrowsePoiShelf___1Qq02"};